import { List } from 'immutable';
import _ from 'lodash';
import APIClient from '../lib/APIClient';
import { resolveAll } from '../helpers/LinkMapper';
import Fare from '../records/Fare';
import { serialiseRailcards } from './JourneyPlanService';
import TicketType from '../records/TicketType';

const RoversRangersService = {

    async search (search) {
        const url = '/jp/rail-rovers';
        const railcards = serialiseRailcards(search);

        let request = {
            start: search.date.format('YYYY-MM-DD'),
            adults: search.adults,
            children: search.children,
            roverCode: search.ticketType.code
        };

        if (railcards.length > 0) {
            request.railcards = railcards;
        }

        const response = await APIClient.post(url, request);
        const requestedFares = resolveAll(response.result).as(Fare);
        const familyFares = await this._getFamilyFares(search, request, url);

        return requestedFares.concat(familyFares).sortBy((fare) => fare.totalPrice);
    },

    async _getFamilyFares(search, request, url) {
        if (search.ticketType.isNonFamilyRanger() &&
            search.adults >= 1 && search.adults <= 2 &&
            search.children >= 1 && search.children <= 4) {

            const familyRequest = _.assign({}, request, { roverCode: TicketType.getFamilyRangerCode() });
            const familyResponse = await APIClient.post(url, familyRequest);

            return resolveAll(familyResponse.result).as(Fare);
        }

        return new List();
    }
};

export default RoversRangersService;



// WEBPACK FOOTER //
// ./src/services/RoversRangersService.js